import type { InvoiceBankAccountLookup } from '../Service/bankAccountsLookupMapper';

const normalizeCurrency = (value: string | undefined): string => value?.trim().toUpperCase() ?? '';

export const selectPreferredBankAccount = (
  accounts: InvoiceBankAccountLookup[],
  invoiceCurrency?: string
): InvoiceBankAccountLookup | undefined => {
  const normalizedInvoiceCurrency = normalizeCurrency(invoiceCurrency);

  if (normalizedInvoiceCurrency) {
    const matchingCurrencyAccount = accounts.find(
      (account) => normalizeCurrency(account.currency) === normalizedInvoiceCurrency
    );

    if (matchingCurrencyAccount) {
      return matchingCurrencyAccount;
    }
  }

  return accounts.find((account) => normalizeCurrency(account.currency) === 'PLN');
};
